
/**
 * 分析类提示语常量
 * 职责: 单个关键词分析、多关键词对比、智能推荐
 */
import type { TemplateType } from '../../../types/ai-analysis-types';
import { SINGLE_ANALYSIS_PROMPT } from './prompts/singleAnalysis';
import { COMPARISON_PROMPT } from './prompts/comparison';
import { RECOMMENDATION_PROMPT } from './prompts/recommendation';
import { COMPETITOR_ANALYSIS_PROMPT } from './prompts/competitorAnalysis';
import { RUFUS_ANALYSIS_PROMPT } from './prompts/rufusAnalysis';

export const ANALYSIS_PROMPTS: Partial<Record<TemplateType, string>> = {
   single_analysis: SINGLE_ANALYSIS_PROMPT,
   comparison: COMPARISON_PROMPT,
   recommendation: RECOMMENDATION_PROMPT,
   competitor_analysis: COMPETITOR_ANALYSIS_PROMPT,
   rufus_analysis: RUFUS_ANALYSIS_PROMPT,
};
